import { createStore } from 'vuex'
import { reports } from '@/store/modules/report'
import _ from 'lodash'
import { notes } from '@/store/modules/notes'
import { session } from '@/store/modules/session/session.store'
import management from '@/store/modules/management/management.store'
import auth from '@/store/modules/auth/auth.store'

export default createStore({
  state: {
    lang: '' as string,
    modal: {},
    toast: {} as any
  },
  mutations: {
    setLang: (state, newLang) => {
      state.lang = newLang
    },
    setModal: (state, payload) => {
      state.modal = { ...state.modal, ...payload }
    },
    setModals: (state, payload) => {
      state.modal = payload
    },
    setToast: (state, payload) => {
      state.toast = payload
    },
    clearToast: state => {
      state.toast = {}
    }
  },

  actions: {
    openModal: (context, payload: string | { name: string; props: any }) => {
      if (_.isString(payload)) {
        context.commit('setModal', { [payload]: true })
      } else {
        context.commit('setModal', { [payload.name]: payload.props })
      }
    },
    closeModal: (context, payload: string) => {
      context.commit('setModal', { [payload]: false })
    },
    closeAllModals: context => {
      context.commit('setModals', {})
    },
    useToast: (context, payload) => {
      const temp = {
        severity: payload?.type ? payload.type : 'info',
        life: 3000,
        summary: payload?.message ? payload.message : '',
        ...payload
      }
      context.commit('setToast', { ...temp })
    },
    clearToast: context => {
      context.commit('clearToast')
    }
  },
  modules: {
    reports,
    notes,
    session,
    management,
    auth
  }
})
